/**
 * Google SSO helpers for Login / Register CTAs (TVD-1292).
 * Browser navigates to API start URL; API redirects through Google then back to /auth/google/callback.
 */

import { clearUserSession } from "./auth-helpers";

export function isGoogleSsoUiEnabled() {
  return String(process.env.REACT_APP_SAAS_GOOGLE_SSO_ENABLED || "").toLowerCase() === "true";
}

export function getGoogleSsoStartUrl({
  intent = "login",
  accountName,
  country,
  currency,
} = {}) {
  const apiBase = String(process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");
  const params = new URLSearchParams();
  params.set("intent", intent === "signup" ? "signup" : "login");
  if (accountName && String(accountName).trim()) {
    params.set("accountName", String(accountName).trim());
  }
  if (intent === "signup") {
    if (country && String(country).trim()) {
      params.set("country", String(country).trim().toUpperCase());
    }
    if (currency && String(currency).trim()) {
      params.set("currency", String(currency).trim().toUpperCase());
    }
  }
  const path = `/auth/google-sso/start?${params.toString()}`;
  return apiBase ? `${apiBase}${path}` : path;
}

export function beginGoogleSso({ intent = "login", accountName, country, currency } = {}) {
  // Drop stale local sessions so a failed Google return cannot reopen dashboard.
  try {
    clearUserSession();
  } catch {
    /* ignore */
  }
  const url = getGoogleSsoStartUrl({ intent, accountName, country, currency });
  if (typeof window !== "undefined") {
    window.location.assign(url);
  }
  return url;
}

export function decodeGoogleSsoSessionParam(sessionParam) {
  if (!sessionParam) {
    return null;
  }
  try {
    const normalized = String(sessionParam).replace(/-/g, "+").replace(/_/g, "/");
    const pad = normalized.length % 4 === 0 ? "" : "=".repeat(4 - (normalized.length % 4));
    const json = atob(normalized + pad);
    return JSON.parse(json);
  } catch {
    return null;
  }
}
